<template>
  <div class="passengers--page">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item label="Departure Date">
          <el-date-picker
            v-model="depatureDate"
            placeholder="Select a date"
            format="yyyy-MM-dd"
            />
        </el-form-item>
        <el-form-item label="By Route">
          <el-select placeholder="Select route" v-model="filterRoute" style="display: block; width: 100%">
            <el-option v-for="(item, idx) in routes"
                       :label="item.description"
                       :key="idx"
                       :value="item.id">
              <div>
                <span >{{ item.from_loc.name }} </span>
                <i class="fas fa-car-side"></i>
                <span style="color: #8492a6; font-size: 13px">{{ item.to_loc.name }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="warning" @click="downloadPDF">
            GENERATE MANIFEST
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <template>
      <el-dialog
        title="Adults"
        :visible.sync="showOthersInfo"
        width="50%"
        center>
        <div v-for="(other, index) in currentOthers" :key="index" style="margin-bottom: 10px">
          <span><strong> Full name </strong>{{ other.full_name }} </span>
          <span><strong> Gender </strong>{{ other.gender }} </span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="showOthersInfo = false">Close</el-button>
        </span>
      </el-dialog>
    </template>
    <div class="passengers" v-if="passengers.length > 0">
      <div class="card" v-for="(passenger, index) in passengers" :key="index">
        <PassengerItem :passenger="passenger" :on-view-adults="showOthers"/>
      </div>
    </div>
    <div style="text-align:center;" v-else>
      <h1>
        Could find any passenger matching this query
      </h1>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'
import { getPassengers } from '@/services/passenger'
import { getRoutes } from '@/services/routes'
import { getTripPassengers } from '@/services/trip'
import PassengerItem from './Item'
import generatePdf from './generateManifest'

export default {
  name: 'Passengers',
  data () {
    return {
      routes: [],
      passengers: [],
      currentOthers: [],
      showOthersInfo: false,
      depatureDate: Date.now(),
      filterRoute: null,
      showMore: false
    }
  },

  components: {
    PassengerItem
  },

  watch: {
    depatureDate (filteredVal) {
      this.loadPassengers(filteredVal)
    },
    filterRoute (newVal) {
      this.loadPassengers()
    }
  },

  created () {
    this.loadRoutes()
  },

  mounted () {
    const id = this.$route.query.tripId
    if (id) {
      this.loadTripPassenger(id)
    } else {
      this.loadPassengers()
    }
  },

  methods: {
    loadRoutes () {
      getRoutes()
        .then(res => {
          this.routes = res.data.filter(r => r.active)
        })
        .catch(() => {
          this.$notify.error({
            message: 'Route not configured'
          })
        })
    },
    loadPassengers () {
      const byDepautureDate = this.depatureDate
      const loading = this.$loading({
        lock: true,
        text: 'Loading passenger for this Depature Date',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      let queryParams = ''
      if (byDepautureDate) {
        const fDate = format(new Date(byDepautureDate), 'YYYY-MM-DD')
        queryParams = `dep_date=${fDate}`
      }
      if (this.filterRoute) {
        queryParams = `${queryParams}&route=${this.filterRoute}`
      }
      getPassengers(queryParams)
        .then(res => {
          loading.close()
          this.passengers = res.data
        })
    },

    loadTripPassenger (id) {
      getTripPassengers(id)
        .then(res => {
          this.passengers = res.data
        })
    },

    showOthers (passenger) {
      this.currentOthers = passenger.others
      this.showOthersInfo = true
    },

    fetchPassengers (filteredDate) {
      // const fDate = format(new Date(parseInt(this.$route.query.departure_date)))
    },

    downloadPDF () {
      if (this.passengers.length > 0) {
        const date = format(new Date(this.depatureDate), 'ddd, DD MMM YYYY')
        generatePdf(this.passengers, date)
      }
    }
  }
}
</script>

<style lang="scss" src="./passengers.scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/passengers/Passengers.vue